// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
    fn_layout_main();
    fn_comp_visual();
    fn_layout_header();
    fn_comp_product_detail();
    fn_part_dialog();
    fn_comp_cart();
});

// --- MISC --- //
$(function () {
    fn_cookie();
    fn_wsw();
    fn_seo_footer();
});